"use client";

import Badge from "@/app/components/lib/badge";
import { useRouter } from "@/app/components/lib/navigation/useRouter";
import SvgQuestionMark from "@/app/components/lib/SvgQuestionMark";
import Tooltip from "@/app/components/lib/tooltip";
import { useTranslation } from "@/hooks/localization/useTranslations";
import { useIsMobile } from "@/hooks/useIsMobile";
import { PagesPaths } from "@/utils/functions/pages-paths";
import { PropsWithChildren } from "react";

interface Props extends PropsWithChildren {
  enableSelling: boolean;
}
const EnableSellingTooltip: React.FC<Props> = ({ children, enableSelling }) => {
  const isMobile = useIsMobile();
  const router = useRouter();
  const t = useTranslation();
  if (enableSelling) return children;
  return (
    <Badge
      badgeStyle={{ width: "100%" }}
      badgeComponent={
        <Tooltip text={t.sign_in_to_view_prices} skip={isMobile}>
          <SvgQuestionMark
            size="25"
            onClick={() => router.push(PagesPaths.signin)}
            style={{ cursor: "pointer" }}
          />
        </Tooltip>
      }
    >
      {children}
    </Badge>
  );
};

export default EnableSellingTooltip;
